var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),(Object.keys(_vm.ipgData).length > 0)?_c('IpgForm',{attrs:{"is-edit-mode":true,"initial-data":_vm.ipgData,"ipg-id":_vm.$route.params.id},on:{"save":_vm.handleSave,"cancel":_vm.handleCancel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }